// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabC_TheComp__r5eDK","Win3":"TabC_Win3__tfW9K"};